import Configurations from '@/features/pos/components/ProductConfigurationModal/Content/parts/Main/parts/Configurations'
import Loader from '@/features/pos/components/ProductConfigurationModal/Content/parts/Main/parts/Loader'
import { useFormIsDefaultValuesInitialized } from '@/features/pos/components/ProductConfigurationModal/form'
import ActionButtons from '@/features/pos/components/ProductConfigurationModal/parts/ActionButtons'
import ProductName from '@/features/pos/components/ProductConfigurationModal/parts/ProductName'
import { Actions, ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'
import React, { FC } from 'react'

type MainProps = {
    productName?: string
    productVariants?: ProductVariant[]
    allowQuantityChange?: boolean
} & Actions

const Main: FC<MainProps> = ({
    productName,
    productVariants,
    allowQuantityChange,
    onConfirm,
    onCancel,
    cancelLabel,
}) => {
    const isFormDefaultValuesInitialized = useFormIsDefaultValuesInitialized()

    return (
        <>
            {productName && <ProductName>{productName}</ProductName>}
            {isFormDefaultValuesInitialized && productVariants ? (
                <Configurations productVariants={productVariants} />
            ) : (
                <Loader />
            )}
            <ActionButtons
                confirmDisabled={!isFormDefaultValuesInitialized}
                allowQuantityChange={allowQuantityChange && isFormDefaultValuesInitialized}
                onConfirm={onConfirm}
                onCancel={onCancel}
                cancelLabel={cancelLabel}
            />
        </>
    )
}

export default Main
